import React from "react";
import NavBar from "./NavBar";
import gadLogo from "../../assets/images/gadLogo.png";
import params from "../../global_parameters";
import classes from "./Header.module.css";

const Header = () => {
  return (
    <header className={classes.headerContainer}>
      <div className={classes.imgContainer}>
        <a
          href="https://www.gov.uk/government/organisations/government-actuarys-department"
          target="_blank"
        >
          <img
            src={gadLogo}
            className={classes.img}
            alt="Government Actuary's Department Logo"
          />
        </a>
      </div>
      <div className={classes.mainHeader}>
        <h1 className={classes.pageTitle}>{params.app_name_long}</h1>
        <NavBar />
      </div>
      <div className={classes.imgContainer} />
    </header>
  );
};

export default Header;
